var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 69.996,
    viewBox: "0 0 70 69.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#58ab27;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.758 53.756)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.758 -53.755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.013,20.83l-4.735,5.313a28.806,28.806,0,1,1-7.5-11.828L58.988,9.58a35,35,0,1,0,8.026,11.248Z",
    transform: "translate(-0.075 -0.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.355,30.439l-.619.7a5.758,5.758,0,0,0,0,7.576l.615.693S36.461,49.8,39.8,53.393c.252.26,1.086.977,1.086.977a3.248,3.248,0,0,0,3.3.441A3.136,3.136,0,0,0,45.322,54L77.846,17.473a3.263,3.263,0,0,0-.026-4.345c-.072-.082-.154-.16-.236-.242s-.183-.141-.271-.219A3.266,3.266,0,0,0,73,13.158L42.6,47.305Z",
    transform: "translate(-8.882 -4.3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.c5bdff79843519e9b870c2b8f02c12c0.svg";
export { ForwardRef as ReactComponent };